import {
  Col,
  Form,
  Row,
  Space,
  VertButton,
  VertInput,
  VertModal,
  VertSelect,
  VertTypography,
} from '@vertem-core/vertice-ds';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';

import { calculatePriceForPoint } from 'Utils/calculatePriceForPoint';
import generateUUID from 'Utils/generateUUID';
import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadRedemptionCategories,
  loadRedemptionSubCategories,
  setResetSubCategories,
} from 'redux/Reducers/Spot/spotNewSolicitationSlice';
import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().required('Campo obrigatório'),
  quantity: yup
    .string()
    .required('Campo obrigatório')
    .min(1, 'Mínimo 1')
    .matches(/^[0-9]+$/, 'Apenas números'),
  unitPrice: yup.string().required('Campo obrigatório'),
  description: yup.string().max(300, 'Máximo 300 caracteres'),
  points: yup.string(),
});

const yupSync = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value });
  },
};

const ModalProduct = ({
  handleCreateProduct,
  showOpen,

  closeModal,
  initialValues = {
    name: '',
    quantity: '',
    unitPrice: '',
    description: '',
    points: '',
    categorias: {
      label: '',
      value: '',
    },
    subCategorias: {
      label: '',
      value: '',
    },
  },
  isEditModal,
  cotacaoPremmiar = false,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { isPMO } = useParticipantSubSegment();

  const quantityWatch = Form.useWatch('quantity', form);
  const descriptionWatch = Form.useWatch('description', form);

  const [points, setPoints] = useState(0);
  const [valueProduct, setValueProduct] = useState(0);
  const [loading, setLoading] = useState(false);

  const Catalog = useSelector(({ Catalog: data }) => data);
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const { dataCategories, dataSubCategories } = useSelector(
    (state) => state.SpotNewSolicitation
  );
  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;

  const headers = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const valueProductDebounced = debounce((value) => {
    setValueProduct(value);
  }, 500);

  const handleSelectChangeCategory = (value) => {
    const { value: valueId } = value;

    form.resetFields(['subCategorias']);

    dispatch(
      loadRedemptionSubCategories({
        id: valueId,
      })
    );
  };

  const handleSelectChangeSubCategory = (value) => {
    console.log('Subcategory selected:', value);
  };

  const valueCategories = dataCategories.map((category) => ({
    value: category.id,
    label: category.name,
  }));

  const valueSubCategories = dataSubCategories.map((subCategory) => ({
    value: subCategory.id,
    label: subCategory.name,
  }));

  useEffect(() => {
    if (isEditModal) {
      let data = {
        ...initialValues,
        unitPrice: initialValues.unitPrice,
      };

      if (!cotacaoPremmiar && isPMO) {
        data = {
          ...data,
          categorias: initialValues.categorias?.value,
          subCategorias: initialValues.subCategorias?.value,
        };
      }

      form.setFieldsValue(data);
      setValueProduct(initialValues.unitPrice);
    }
  }, [isEditModal, initialValues]);

  useEffect(() => {
    const validateProduct = valueProduct !== 0 && !isNaN(valueProduct);
    if (quantityWatch && validateProduct) {
      let value = parseFloat(quantityWatch) * valueProduct;

      async function calculatePrice() {
        setLoading(true);
        const points = await calculatePriceForPoint(value, headers);
        setPoints(points);
        setLoading(false);
      }
      calculatePrice();
    }
  }, [quantityWatch, valueProduct]);

  return (
    <VertModal
      centered
      open={showOpen}
      onCancel={loading ? () => {} : closeModal}
      onOk={closeModal}
      title={isEditModal ? 'Editar Produto' : 'Adicionar Produto'}
      className="vert-modal-product-spot"
      footer={[
        <div className="vert-modal-product-spot__footer">
          <VertButton
            key="back"
            type="highlight"
            htmlType="submit"
            form={
              isEditModal
                ? 'vert-modal-product-spot__form_edit'
                : 'vert-modal-product-spot__form_create'
            }
            loading={loading}
          >
            {isEditModal ? 'Editar' : 'Adicionar'} Produto
          </VertButton>
          <VertButton
            key="submit"
            type="default"
            onClick={closeModal}
            disabled={loading}
          >
            Fechar
          </VertButton>
        </div>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        defaultValue={initialValues}
        onFinish={(values) => {
          let data = {
            id: isEditModal ? initialValues.id : generateUUID(),
            ...values,
            unitPrice: valueProduct,
            points: values.points,
          };

          if (!cotacaoPremmiar && isPMO) {
            let categoryLabel = dataCategories.find(
              (category) => category.id === data.categorias
            )?.name;
            let subCategoryLabel = dataSubCategories.find(
              (subCategory) => subCategory.id === data.subCategorias
            )?.name;

            data = {
              ...data,
              categoryName: values.categorias.label || categoryLabel,
              subCategoryName: values.subCategorias.label || subCategoryLabel,
              categoryId: values.categorias.value || data?.categorias,
              subCategoryId: values.subCategorias.value || data?.subCategorias,
            };
          }

          handleCreateProduct(data);
          form.resetFields();
          setValueProduct(0);
          setPoints(0);
        }}
        id={
          isEditModal
            ? 'vert-modal-product-spot__form_edit'
            : 'vert-modal-product-spot__form_create'
        }
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="name" rules={[yupSync]}>
              <VertInput label="Nome do produto" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="quantity" rules={[yupSync]}>
              <VertInput label="Quantidade" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="unitPrice" rules={[yupSync]}>
              <div className="vert-input vert-input-number-spot">
                <label className="shrink-label">Preço</label>
                <NumericFormat
                  name="unitPrice"
                  prefix={'R$ '}
                  value={valueProduct}
                  thousandSeparator="."
                  decimalSeparator=","
                  allowNegative={false}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  onValueChange={(values) => {
                    valueProductDebounced(values.floatValue);
                  }}
                />
              </div>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="points" rules={[yupSync]}>
              <div
                className="vert-input vert-input-number-spot"
                style={{
                  backgroundColor: '#FAF6F8',
                }}
              >
                <label className="shrink-label">Valor em {pointsName}</label>
                <NumericFormat
                  name="points"
                  value={points}
                  allowNegative={false}
                  decimalScale={decimalPlaces}
                  thousandSeparator="."
                  decimalSeparator=","
                  fixedDecimalScale={true}
                  disabled
                  className="cursor-not-allowed-spot"
                />
              </div>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="description" rules={[yupSync]}>
              <VertInput.TextArea
                className="modal-text-area"
                placeholder="Descrição do produto"
              />
            </Form.Item>
            {/* create counter */}
            <VertTypography.Text className="counter-text-area-modal">
              {descriptionWatch?.length ? descriptionWatch.length : 0}/300
            </VertTypography.Text>
          </Col>

          {!cotacaoPremmiar && isPMO && (
            <>
              <Col span={24}>
                <Space size="small">
                  <VertTypography.Paragraph>Categoria</VertTypography.Paragraph>
                </Space>
                <Form.Item
                  name="categorias"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório',
                    },
                  ]}
                >
                  <VertSelect
                    items={valueCategories}
                    placeholder="Categoria do Produto"
                    onChange={handleSelectChangeCategory}
                    showSearch
                    labelInValue
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Space size="small">
                  <VertTypography.Paragraph>
                    Subcategoria
                  </VertTypography.Paragraph>
                </Space>
                <Form.Item
                  name="subCategorias"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório',
                    },
                  ]}
                >
                  <VertSelect
                    items={valueSubCategories}
                    placeholder="Subcategoria do Produto"
                    onChange={handleSelectChangeSubCategory}
                    disabled={!valueSubCategories.length}
                    showSearch
                    labelInValue
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      </Form>
    </VertModal>
  );
};

export default ModalProduct;
